import React, { useState } from 'react';
import { Alert, Button, Form, Modal, Space, message } from 'antd';
import { guardarRolesEmpleado } from '../../api/empleadosApi';
import type { EmpleadosCatalogos } from '../../api/empleadosApi';
import { ayuda } from './ayudas';
import { AvisoRoles, SelectorRoles } from './CamposEmpleado';
import { errorEmpleado } from './errores';
import type { ErrorEmpleado } from './errores';

interface Props {
  abierto: boolean;
  idEmpleado: number;
  rolesActuales: string[];
  catalogos: EmpleadosCatalogos | null;
  onCerrar: () => void;
  onGuardado: () => void;
}

/** Roles del empleado: sustituye el conjunto entero (vacío = sin roles). */
export const RolesModal: React.FC<Props> = ({ abierto, idEmpleado, rolesActuales, catalogos, onCerrar, onGuardado }) => (
  <Modal open={abierto} onCancel={onCerrar} title="Roles" footer={null} destroyOnClose maskClosable={false}>
    {abierto && (
      <Contenido idEmpleado={idEmpleado} rolesActuales={rolesActuales} catalogos={catalogos} onCerrar={onCerrar} onGuardado={onGuardado} />
    )}
  </Modal>
);

const Contenido: React.FC<Omit<Props, 'abierto'>> = ({ idEmpleado, rolesActuales, catalogos, onCerrar, onGuardado }) => {
  const [roles, setRoles] = useState<string[]>(rolesActuales);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState<ErrorEmpleado | null>(null);

  const guardar = async () => {
    setGuardando(true);
    setError(null);
    try {
      await guardarRolesEmpleado(idEmpleado, roles);
      message.success('Roles guardados.');
      onGuardado();
      onCerrar();
    } catch (e) {
      setError(errorEmpleado(e));
    } finally {
      setGuardando(false);
    }
  };

  return (
    <>
      <AvisoRoles />
      <Form layout="vertical" onFinish={guardar}>
        <Form.Item label="Roles" htmlFor="empleado-roles" extra={`${ayuda('roles')} Lo que elijas sustituye a los roles actuales.`}>
          <SelectorRoles id="empleado-roles" catalogo={catalogos?.roles ?? []} actuales={rolesActuales} value={roles} onChange={setRoles} />
        </Form.Item>
        {error && <Alert type="error" showIcon message={error.mensaje} style={{ marginBottom: 16 }} />}
        <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onCerrar}>Cancelar</Button>
          <Button type="primary" htmlType="submit" loading={guardando}>Guardar roles</Button>
        </Space>
      </Form>
    </>
  );
};
